export default {
      id: "laptop-usage",
      viewBox: "0 0 36 25",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#laptop",
      toString: function () {
        return this.url;
      }
    }